import './styles.scss'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Toast } from 'primereact/toast'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'

const AccordionPopUp = ({ setLoading, mockCoffeePriceHistoryData, selectedQualityForHistoryData, setSelectedQualityForHistoryData, accordionPopUpTest }) => {
  const [countryId, countryName, cropYear, qualityName, forexType, flagUrl, remarks] = selectedQualityForHistoryData

  const { t } = useTranslation()
  const toast = useRef(null)
  const timerRef = useRef(null)
  const rowRefs = useRef({})
  const scrollContainerRef = useRef(null)

  const [coffeePriceHistoryData, setCoffeePriceHistoryData] = useState([])
  const [isDialogModalOpen, setIsDialogModalOpen] = useState(false)
  const [selectedHighCropYear, setSelectedHighCropYear] = useState({})
  const [selectedLowCropYear, setSelectedLowCropYear] = useState({})
  const [cropYearList, setCropYearList] = useState([])

  const [highCropYearData, setHighCropYearData] = useState([])
  const [lowCropYearData, setLowCropYearData] = useState([])
  const [highlightedRowDate, setHighlightedRowDate] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)
  const [dropdownValue, setDropdownValue] = useState('')

  useEffect(() => {
    if (selectedQualityForHistoryData?.length) {
      fetchHistoryData()
      setIsDialogModalOpen(false)
    }
  }, [selectedQualityForHistoryData])

  useEffect(() => {
    if (accordionPopUpTest) {
      setIsDialogModalOpen(true)
      setCoffeePriceHistoryData(mockCoffeePriceHistoryData)
    }
  }, [])

  useEffect(() => {
    if (Object.keys(selectedHighCropYear).length > 0) {
      handleCropYearHighLowValue()
    }
  }, [selectedHighCropYear, selectedLowCropYear])

  useEffect(() => {
    if (!isDialogModalOpen) {
      setSelectedQualityForHistoryData([])
    }
  }, [isDialogModalOpen])

  useEffect(() => {
    document.body.style.overflow = isDialogModalOpen ? 'hidden' : ''

    return () => {
      document.body.style.overflow = ''
    }
  }, [isDialogModalOpen])

  const fetchHistoryData = async () => {
    setLoading(true)
    try {
      const response = await apiAdapterCoffeeWeb.getGlobalCoffeePriceHistoryData({ idCountry: countryId, countryName, cropYear, qualityName })

      if (response.data.returnLst?.length > 0) {
        const historyDataList = response.data.returnLst[0].data

        const modifiedHistoryDataList = historyDataList.map((ele, index) => {
          const prevData = historyDataList[index + 1] || {}

          return {
            ...ele,
            rangeStartTextColor: Number(ele.convertedRangeStart) >= Number(prevData.convertedRangeStart) || 0 ? 'value-high' : 'value-low',
            rangeEndTextColor: Number(ele.convertedRangeEnd) >= Number(prevData.convertedRangeEnd) || 0 ? 'value-high' : 'value-low'
          }
        })

        const uniqueCropYearsMap = new Map()
        const uniqueCropYearsList = []

        modifiedHistoryDataList.forEach((item) => {
          if (!uniqueCropYearsMap.has(item.cropYear)) {
            uniqueCropYearsMap.set(item.cropYear, true)

            uniqueCropYearsList.push({
              id: uniqueCropYearsList?.length,
              cropYear: item.cropYear
            })
          }
        })

        setCoffeePriceHistoryData(modifiedHistoryDataList)
        setCropYearList(uniqueCropYearsList)
        setSelectedHighCropYear(uniqueCropYearsList[0])
        setSelectedLowCropYear(uniqueCropYearsList[0])
        setIsDialogModalOpen(true)
      } else {
        showErrorToast('NO_DATA_FOUND')
        setCoffeePriceHistoryData([])
      }
    } catch (error) {
      showErrorToast('FAILED_TO_GET_DATA')
      setCoffeePriceHistoryData([])
    } finally {
      setLoading(false)
    }
  }

  const handleHighLowCropYearDropdownChange = (e, dropdownType) => {
    const selectedCropYear = cropYearList.find((ele) => ele.id === Number(e.target.value))

    if (dropdownType === 'high') {
      setSelectedHighCropYear(selectedCropYear)
    } else {
      setSelectedLowCropYear(selectedCropYear)
    }

    setDropdownValue(dropdownType)
  }

  const handleCropYearHighLowValue = () => {
    const filteredCropYearDataForHigh = coffeePriceHistoryData?.filter(({ cropYear }) => cropYear === selectedHighCropYear.cropYear)
    const filteredCropYearDataForLow = coffeePriceHistoryData?.filter(({ cropYear }) => cropYear === selectedLowCropYear.cropYear)

    let highRangeEnd = -Infinity
    let lowRangeEnd = Infinity

    filteredCropYearDataForHigh.forEach((ele) => {
      const { convertedRangeEnd } = ele

      if (Number(convertedRangeEnd) > highRangeEnd) {
        highRangeEnd = Number(convertedRangeEnd)
      }
    })

    filteredCropYearDataForLow.forEach((ele) => {
      const { convertedRangeEnd } = ele

      if (Number(convertedRangeEnd) < lowRangeEnd) {
        lowRangeEnd = Number(convertedRangeEnd)
      }
    })

    const modifiedCoffeePriceHistoryData = coffeePriceHistoryData.map((ele) => ({
      ...ele,
      isHigh: ele.cropYear === selectedHighCropYear.cropYear && Number(ele.convertedRangeEnd) === highRangeEnd,
      isLow: ele.cropYear === selectedLowCropYear.cropYear && Number(ele.convertedRangeEnd) === lowRangeEnd
    }))

    setHighCropYearData(modifiedCoffeePriceHistoryData.filter(({ isHigh }) => isHigh))
    setLowCropYearData(modifiedCoffeePriceHistoryData.filter(({ isLow }) => isLow))
    setCoffeePriceHistoryData(modifiedCoffeePriceHistoryData)
  }

  const handleShowHighLowModal = (dropdownType) => {
    setDropdownValue(dropdownType)
    setOpenDialog(true)
  }

  const handleClickToHighlightRow = (uploadedDtm) => {
    const container = scrollContainerRef.current
    const target = rowRefs.current[uploadedDtm]

    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    if (container && target) {
      const targetOffsetTop = target.offsetTop

      container.scrollTop = targetOffsetTop - 250

      setHighlightedRowDate(uploadedDtm)
      timerRef.current = setTimeout(() => {
        setHighlightedRowDate(null)
      }, 20000)
    }
  }

  const handleCloseModal = () => {
    setIsDialogModalOpen(false)
    setOpenDialog(false)
    setHighlightedRowDate(null)
  }

  const showErrorToast = (message) => toast.current?.show({ severity: 'error', summary: 'Error', detail: t(message), life: 3000 })

  const priceColumnName = () => {
    if (!forexType) return ''

    const forexTypes = forexType.split(',').map((item) => item.replace(/INR\/|\/INR/g, '').trim())
    const result = [...new Set(forexTypes)]

    return `Prices in ${result} (${remarks})`
  }

  const priceForTheRemarks = () => {
    if (!remarks) return ''

    return `Prices in INR (${remarks})`
  }

  const renderBodyContent = () => {
    const groupedData = dropdownValue === 'high' ? highCropYearData : lowCropYearData

    return (
      <div className="coffeeprice-high-low-data-container">
        <div className="sub-title">
          {dropdownValue === 'high' ? (
            <>
              {t('HIGH_PRICE_RECORD_BETWEEN')} <b>{selectedHighCropYear?.cropYear}</b>
            </>
          ) : (
            <>
              {t('LOW_PRICE_RECORD_BETWEEN')} <b>{selectedLowCropYear?.cropYear}</b>
            </>
          )}
        </div>
        <div className="scrollbar-table-wrapper">
          <table className="high-low-data-table">
            <thead>
              <tr>
                <th>{t('DATE')}</th>
                <th colSpan={2}>{t('BETWEEN')}</th>
              </tr>
            </thead>
            <tbody>
              {groupedData.map(({ uploadedDtm, convertedRangeStart, convertedRangeEnd, rangeStartTextColor, rangeEndTextColor }, index) => (
                <tr key={index}>
                  <td width={210}>
                    <div className="date-col" onClick={() => handleClickToHighlightRow(uploadedDtm)}>
                      {uploadedDtm}
                      <span className="pi pi-arrow-circle-right"></span>
                    </div>
                  </td>
                  <td className={rangeStartTextColor}>{convertedRangeStart}</td>
                  <td className={rangeEndTextColor}>{convertedRangeEnd}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  const globalRawCoffeesModalContent = () => (
    <div className="global-coffee-price-popup-modal" data-testid="global-raw-coffee-price-modal-popup">
      <div ref={scrollContainerRef} className="global-raw-coffee-price-preview-table-wrapper" data-testid="global-raw-coffee-price-table-wrapper">
        <table className="global-raw-coffee-price-preview-table" data-testid="global-raw-coffee-price-table-preview">
          <thead className="global-raw-coffee-price-preview-table-header" data-testid="global-raw-coffee-price-preview-header">
            <tr style={{ borderBottom: 'none' }}>
              <th className="cropyear-high-th" colSpan={2}>
                <div className="card">
                  <div>
                    <div className="high-low-select-div">
                      <div className="high-text">
                        {t('HIGH')} :
                        <select value={selectedHighCropYear?.id} onChange={(e) => handleHighLowCropYearDropdownChange(e, 'high')}>
                          {cropYearList.map((ele) => (
                            <option key={ele.id} value={ele.id}>
                              {ele.cropYear}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="details">
                        {t('BETWEEN')} :{' '}
                        <span>
                          {highCropYearData[0]?.convertedRangeStart} - {highCropYearData[0]?.convertedRangeEnd}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="high-low-date-div">
                    <div className="details">
                      {t('DATE')} : {highCropYearData[0]?.uploadedDtm}
                    </div>

                    <div className="see-more-button">
                      <p onClick={() => handleShowHighLowModal('high')}>{t('SEE_MORE')}</p>
                    </div>
                  </div>
                </div>
              </th>
              <th colSpan={countryName === 'India' ? 3 : 5} className="quality-name-title-th-wrapper">
                <div className="quality-name-title">
                  <div className="table-title">{t('PREVIOUS_DATA')}</div>
                  <div className="quality-name-detail">
                    {qualityName} ( <img src={flagUrl} alt="Flag" className="flag-icon" data-testid="flag-icon" /> {countryName})
                  </div>
                </div>
              </th>
              <th className="cropyear-low-th" colSpan={countryName === 'India' ? 4 : 5}>
                <div className="card">
                  <div>
                    <div className="high-low-select-div">
                      <div className="low-text">
                        {t('LOW')} :
                        <select value={selectedLowCropYear?.id} onChange={(e) => handleHighLowCropYearDropdownChange(e, 'low')}>
                          {cropYearList.map((ele) => (
                            <option key={ele.id} value={ele.id}>
                              {ele.cropYear}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="details">
                        {t('BETWEEN')} :{' '}
                        <span>
                          {lowCropYearData[0]?.convertedRangeStart} - {lowCropYearData[0]?.convertedRangeEnd}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="high-low-date-div">
                    <div className="details">
                      {t('DATE')} : {lowCropYearData[0]?.uploadedDtm}
                    </div>
                    <div className="see-more-button">
                      <p onClick={() => handleShowHighLowModal('low')}>{t('SEE_MORE')}</p>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
            <tr>
              <th colSpan={2} className="header-country" data-testid="crop-year-flag">
                {t('COUNTRY')} : <img src={flagUrl} alt="Flag" className="flag-icon" data-testid="flag-icon" /> {countryName}
              </th>
              <th colSpan={countryName === 'India' ? 3 : 5} className="empty-th" data-testid="previous-data-header"></th>
              <th colSpan={countryName === 'India' ? 4 : 5} className="header-quality" data-testid="quality-name">
                {qualityName}
              </th>
            </tr>
            <tr>
              <th rowSpan={2} className="accordion-date-tr">
                {t('DATE')}
              </th>
              <th rowSpan={2} data-testid="crop-year">
                {t('CROP_YEAR')}
              </th>
              <th rowSpan={2}>{t('TERMINAL')}</th>
              <th rowSpan={2}>{t('TERMINAL_LEVEL')}</th>
              {countryName === 'India' ? (
                <>
                  <th rowSpan={2} data-testid="forex-type">
                    {forexType}
                  </th>
                  <th colSpan={2} data-testid="price-remarks">
                    {priceForTheRemarks()}
                  </th>
                </>
              ) : (
                <>
                  <th colSpan={2} data-testid="price-column-non-indian">
                    {priceColumnName()}
                  </th>
                  <th rowSpan={2} data-testid="forex-type-non-indian">
                    {forexType}
                  </th>
                  <th colSpan={2} data-testid="price-remarks-non-india">
                    {priceForTheRemarks()}
                  </th>
                </>
              )}
            </tr>
            <tr>
              <th colSpan={2} className="between-header">
                {t('BETWEEN')}
              </th>
              {countryName !== 'India' && (
                <th colSpan={2} className="between-header">
                  {t('BETWEEN')}
                </th>
              )}
            </tr>
          </thead>

          {coffeePriceHistoryData.length > 0 ? (
            <tbody className="global-raw-coffee-price-preview-table-body" data-testid="global-raw-coffee-price-table-body">
              {coffeePriceHistoryData.length > 0 ? (
                coffeePriceHistoryData.map(({ uploadedDtm, cropYear, terminal, terminalLevel, rangeStart, rangeEnd, forexValue, convertedRangeStart, convertedRangeEnd, isHigh, isLow, rangeStartTextColor, rangeEndTextColor }, index) => {
                  const prevData = coffeePriceHistoryData[index + 1] || {}

                  return (
                    <tr
                      key={index}
                      ref={(el) => {
                        rowRefs.current[uploadedDtm] = el
                      }}
                      style={{
                        backgroundColor: highlightedRowDate === uploadedDtm ? '#50b3f655' : 'transparent'
                      }}
                    >
                      <td data-testid="uploadedDtm-value" className="date-td">
                        {uploadedDtm}
                      </td>
                      <td data-testid="cropYear-value">{cropYear}</td>
                      <td data-testid="terminal-value" className="terminal-data-value">
                        {terminal}
                      </td>
                      <td data-testid="terminal-level-value" className="terminal-data-value">
                        {terminalLevel}
                      </td>
                      {countryName === 'India' ? (
                        <>
                          <td data-testid="forex-value">{forexValue}</td>
                          <td data-testid="range-start-value" className={rangeStartTextColor}>
                            {rangeStart}
                            <span className="high-low-marker">
                              {isHigh && 'H'}
                              {isLow && 'L'}
                            </span>
                          </td>
                          <td data-testid="range-end-value" className={rangeEndTextColor}>
                            {rangeEnd}
                            <span className="high-low-marker">
                              {isHigh && 'H'}
                              {isLow && 'L'}
                            </span>
                          </td>
                        </>
                      ) : (
                        <>
                          <td data-testid="converted-range-start-value">{rangeStart}</td>
                          <td data-testid="converted-range-end-value">{rangeEnd}</td>
                          <td data-testid="forex-value">{forexValue}</td>

                          <td data-testid="range-start-value" className={convertedRangeStart >= (prevData.convertedRangeStart || 0) ? 'value-high' : 'value-low'}>
                            {convertedRangeStart}{' '}
                            <span className="high-low-marker">
                              {isHigh && 'H'}
                              {isLow && 'L'}
                            </span>
                          </td>
                          <td data-testid="range-end-value" className={convertedRangeEnd >= (prevData.convertedRangeEnd || 0) ? 'value-high' : 'value-low'}>
                            {convertedRangeEnd}
                            <span className="high-low-marker">
                              {isHigh && 'H'}
                              {isLow && 'L'}
                            </span>
                          </td>
                        </>
                      )}
                    </tr>
                  )
                })
              ) : (
                <tr></tr>
              )}
            </tbody>
          ) : (
            <tbody className="global-raw-coffee-price-preview-table-body">
              <tr>
                <td className="no-data-found-td" colSpan={7}>
                  {t('NO_DATA_FOUND')}
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </div>
  )

  return (
    <div className="global-raw-coffee-price-accordian-popup" data-testid="global-raw-coffee-price-accordion-popup">
      <DialogUIModal titlePosition="center" size="lg" showModal={isDialogModalOpen} bodyContent={globalRawCoffeesModalContent} handleClose={() => handleCloseModal()} testId="accordion-popup" />
      {coffeePriceHistoryData.length === 0 && <Toast ref={toast} />}

      <DialogUIModal position="top" hideOverlay={true} showModal={openDialog} bodyContent={renderBodyContent} handleClose={() => setOpenDialog(false)} />
    </div>
  )
}

export default AccordionPopUp
